import React, { useState, useEffect, useRef, useCallback } from "react";
import { styled, useTheme } from "@mui/material/styles";
import { DataGrid, GridToolbar, GridToolbarContainer, GridToolbarQuickFilter } from "@mui/x-data-grid";
import Box from "@mui/material/Box";
import "./style.css";
import "react-datepicker/dist/react-datepicker.css";
import Pagination from '@mui/material/Pagination';
import MSelect from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import CircleIcon from '@mui/icons-material/Circle';
import { useMediaQuery } from "react-responsive";
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowDropUpSharpIcon from '@mui/icons-material/ArrowDropUpSharp';
import SquareIcon from '@mui/icons-material/Square';
import { Tooltip } from "@mui/material";
import { Download } from "@mui/icons-material";


export default function DatagridComp({
  columns, rows, autoheightval, datagridval, columnFreezeWidth, customToolFunction,
  checkbox, setSelectedRows, tableLoading, customFilter, DownloadShowPDF, DownloadShowCSV,
  DownloadShowFile, handleModelPopUp, handleDownlodingCSV, handleDownlodingPDF, defaultPerPage
}) {
  const freezeColumnWidth = columnFreezeWidth ? columnFreezeWidth : [];
  // const freezeColumnWidth = []; // for remove freeze
  const freezeColumnLength = freezeColumnWidth.length;
  const [dataGridSx, setDataGridSx] = useState({});
  const [dataGridSxHeader, setDataGridSxHeader] = useState({});
  const isMobile = useMediaQuery({ maxWidth: 100 });
  const isTabletView = window.innerWidth <= 768;
  const StyledGridOverlay = styled("div")(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "100%",
    "& .ant-empty-img-1": {
      fill: theme.palette.mode === "light" ? "#aeb8c2" : "#262626",
    },
    "& .ant-empty-img-2": {
      fill: theme.palette.mode === "light" ? "#f5f5f7" : "#595959",
    },
    "& .ant-empty-img-3": {
      fill: theme.palette.mode === "light" ? "#dce0e6" : "#434343",
    },
    "& .ant-empty-img-4": {
      fill: theme.palette.mode === "light" ? "#fff" : "#1c1c1c",
    },
    "& .ant-empty-img-5": {
      fillOpacity: theme.palette.mode === "light" ? "0.8" : "0.08",
      fill: theme.palette.mode === "light" ? "#f5f5f5" : "#fff",
    },
  }));


  const dropdownRef = useRef();
  const [download, setDownload] = useState(false);
  const menuItemStyle = {
    padding: "10px 16px",
    cursor: "pointer",
    borderBottom: "1px solid #eee",
    backgroundColor: "#fff",
    transition: "background 0.2s",
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDownload(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);


  const freezeColumn = (columnsCount = freezeColumnWidth) => {
    if (columnsCount.length > 0 && !isTabletView) {
      const dataGridSx1 = {};
      const dataGridSxHeader1 = {};

      for (let i = 1; i <= columnsCount.length; i++) {
        dataGridSx1[`& .MuiDataGrid-row:hover .MuiDataGrid-cell:nth-child(${i})`] = {
          backgroundColor: '#f2efef'
        };
        dataGridSx1['& .MuiDataGrid-row.Mui-selected .MuiDataGrid-cell[data-field="select"]'] = {
          backgroundColor: '#f2efef',
        };
        dataGridSx1[`& .MuiDataGrid-cell:nth-child(${i})`] = {
          position: isTabletView ? "relative" : "sticky",
          top: "0",
          left: isTabletView ? 'none' : (columnsCount[i - 1] + 'px' || '0px'),
          paddingLeft: "1.5rem",
          zIndex: 999,
          backgroundColor: "#ffffff",
          border: "none",
          alignContent: "center"
        };
      }
      setDataGridSx(dataGridSx1);
      for (let i = 1; i <= columnsCount.length; i++) {
        dataGridSxHeader1[`& .MuiDataGrid-columnHeader:nth-child(${i})`] = {
          backgroundColor: "#f4f3f3",
          zIndex: 999,
        };
      }
      setDataGridSxHeader(dataGridSxHeader1);
    }
  }


  const MyCustomNoRowsOverlay = () => {
    return (
      <StyledGridOverlay>
        <svg
          width="120"
          height="100"
          viewBox="0 0 184 152"
          aria-hidden
          focusable="false"
        >
          <g fill="none" fillRule="evenodd">
            <g transform="translate(24 31.67)">
              <ellipse
                className="ant-empty-img-5"
                cx="67.797"
                cy="106.89"
                rx="67.797"
                ry="12.668"
              />
              <path
                className="ant-empty-img-1"
                d="M122.034 69.674L98.109 40.229c-1.148-1.386-2.826-2.225-4.593-2.225h-51.44c-1.766 0-3.444.839-4.592 2.225L13.56 69.674v15.383h108.475V69.674z"
              />
              <path
                className="ant-empty-img-2"
                d="M33.83 0h67.933a4 4 0 0 1 4 4v93.344a4 4 0 0 1-4 4H33.83a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4z"
              />
              <path
                className="ant-empty-img-3"
                d="M42.678 9.953h50.237a2 2 0 0 1 2 2V36.91a2 2 0 0 1-2 2H42.678a2 2 0 0 1-2-2V11.953a2 2 0 0 1 2-2zM42.94 49.767h49.713a2.262 2.262 0 1 1 0 4.524H42.94a2.262 2.262 0 0 1 0-4.524zM42.94 61.53h49.713a2.262 2.262 0 1 1 0 4.525H42.94a2.262 2.262 0 0 1 0-4.525zM121.813 105.032c-.775 3.071-3.497 5.36-6.735 5.36H20.515c-3.238 0-5.96-2.29-6.734-5.36a7.309 7.309 0 0 1-.222-1.79V69.675h26.318c2.907 0 5.25 2.448 5.25 5.42v.04c0 2.971 2.37 5.37 5.277 5.37h34.785c2.907 0 5.277-2.421 5.277-5.393V75.1c0-2.972 2.343-5.426 5.25-5.426h26.318v33.569c0 .617-.077 1.216-.221 1.789z"
              />
            </g>
            <path
              className="ant-empty-img-3"
              d="M149.121 33.292l-6.83 2.65a1 1 0 0 1-1.317-1.23l1.937-6.207c-2.589-2.944-4.109-6.534-4.109-10.408C138.802 8.102 148.92 0 161.402 0 173.881 0 184 8.102 184 18.097c0 9.995-10.118 18.097-22.599 18.097-4.528 0-8.744-1.066-12.28-2.902z"
            />
            <g className="ant-empty-img-4" transform="translate(149.65 15.383)">
              <ellipse cx="20.654" cy="3.167" rx="2.849" ry="2.815" />
              <path d="M5.698 5.63H0L2.898.704zM9.259.704h4.985V5.63H9.259z" />
            </g>
          </g>
        </svg>
        <Box sx={{ mt: 1 }}>{(tableLoading || rows.length > 0) ? 'In Progress' : 'No Data'}</Box>
      </StyledGridOverlay>
    )
  };


  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(defaultPerPage ? defaultPerPage : 10);
  const [searchQuery, setSearchQuery] = useState("");
  const searchInputRef = useRef(null);
  const [tableHeight, setTableHeight] = useState({ mobile: 800, web: 550 });
  const [draggingColumn, setDraggingColumn] = useState(null);
  const [currentColumns, setCurrentColumns] = useState(columns);

  const [rowLength, setRowLength] = useState(0);

  const [hasintersected, setHasintersected] = useState(false);


  // const filteredRows = Array.isArray(rows) ? rows.filter((row) => {
  //   return Object.values(row).some((value) => {
  //     if (value != null && value != undefined) {
  //       return value.toString().toLowerCase().includes(searchQuery.toLowerCase());
  //     }
  //     return false;
  //   }
  //   );
  // }) : [];


  const filteredRows = Array.isArray(rows)
    ? rows.filter(row =>
      JSON.stringify(Object.values(row))
        .toLowerCase()
        .includes(searchQuery.toLowerCase())
    )
    : [];


  const totalPages = Math.ceil(filteredRows.length / rowsPerPage);

  const handlePageChange = (event, value) => {
    setPage(value);
  };

  const handleRowsPerPageChange = (event) => {
    setRowsPerPage(event.target.value);
    setPage(1);
    if (event.target.value == 10) {
      setTableHeight({ mobile: 800, web: 550 });
    }
    if (event.target.value == 30) {
      setTableHeight({ mobile: 1000, web: 700 });
    }
    if (event.target.value == 50) {
      setTableHeight({ mobile: 1100, web: 800 });
    }
    if (event.target.value == 75) {
      setTableHeight({ mobile: 1200, web: 900 });
    }
    if (event.target.value == 100) {
      setTableHeight({ mobile: 1300, web: 1000 });
    }
  };

  const handleSearchChange = useCallback((event) => {
    setSearchQuery(event.target.value);  // Update search query
    setPage(1);
  }, []);


  const handleDragStart = (e, column) => {
    setDraggingColumn(column);
    e.dataTransfer.setData('text/plain', column.field);
  };

  const handleDragOver = (e, targetColumn) => {
    e.preventDefault();
    const draggedColumn = draggingColumn;
    // if (draggedColumn) {  // this if condition is drag & drop for freezed column also
    if (draggedColumn &&
      (freezeColumnLength < 1 ||
        (currentColumns.indexOf(draggedColumn) > freezeColumnLength - 1 &&   // this if condition is don't drag & drop for freezed column
          currentColumns.indexOf(targetColumn) > freezeColumnLength - 1)
      )
    ) {
      const updatedColumns = [...currentColumns];
      const draggedIndex = currentColumns.indexOf(draggedColumn);
      const targetIndex = currentColumns.indexOf(targetColumn);

      updatedColumns[draggedIndex] = targetColumn;
      updatedColumns[targetIndex] = draggedColumn;

      if (freezeColumnLength > 0 && (
        (freezeColumnLength - 1) >= draggedIndex || (freezeColumnLength - 1) >= targetIndex
      )
      ) {
        const columnFreeze = [0].concat(updatedColumns.filter((uc, i) => {
          if ((freezeColumnLength - 2) >= i) {
            return uc.minWidth;
          }
        }).map(c => c.minWidth));
        freezeColumn(columnFreeze);
      }

      setCurrentColumns(updatedColumns);
    }
  };

  const handleDrop = (e, targetColumn) => {

  };

  const customColumnHeader = (column) => {
    return (
      <Box
        draggable
        onDragStart={(e) => handleDragStart(e, column)}
        onDragOver={(e) => handleDragOver(e, column)}
        onDrop={(e) => handleDrop(e, column)}
        style={{
          // cursor: currentColumns.indexOf(column) > freezeColumnLength - 1 ? 'grab' : 'cursor', // seperate for style for freeze
          // cursor: 'grab',
          padding: '10px',
          backgroundColor: '#f5f5f5',
          fontSize: '15px',
          fontWeight: '500',
          textAlign: 'center',
          fontFamily: 'Poppins, sans-serif',
          whiteSpace: 'normal',
          lineHeight: 'normal'
        }}
      >
        {column?.renderHeader ? (
          // If renderHeader is a function, call it with empty params or actual params if available
          column.renderHeader({ colDef: column }) // or just `column.renderHeader()` if no param expected
        ) : (
          <Tooltip title={column?.description || ''}>
            {column?.headerName || ''}
          </Tooltip>
        )}
      </Box>
    );
  };

  const columnsWithDrag = currentColumns
    .filter(Boolean) // removes undefined/null entries
    .map((col) => ({
      ...col,
      renderHeader: () => customColumnHeader(col),
    }));

  const handleBlur = () => {
    setHasintersected(false);
  };

  const CustomToolbar5 = () => {
    return (
      <GridToolbarContainer style={{ background: "#fff", display: "flex", justifyContent: "end", alignItems: "center" }}>
        <div style={{ display: "flex", gap: "16px", alignItems: "center", justifyContent: "end", marginRight: "13px" }}>
          {customFilter &&
            <div>
              <div className="dashboard_download" onClick={handleModelPopUp}>
                Filter
                <svg
                  className="filter"
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  viewBox="0 0 24 24"
                  style={{ cursor: "pointer" }}
                >
                  <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3" />
                </svg>
              </div>
            </div>}
          {DownloadShowFile &&
            <div>
              <div
                ref={dropdownRef}
                style={{
                  position: "relative",
                  display: "inline-block",
                  border: "1px solid #ff6600",
                  borderRadius: "99rem",
                }}
              >
                <button
                  className="dashboard_download"
                  onClick={() => setDownload((prev) => !prev)}
                >
                  Download{" "}
                  <svg
                    className="filter"
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    viewBox="0 0 24 24"
                  >
                    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                    <polyline points="7 10 12 15 17 10" />
                    <line x1="12" y1="15" x2="12" y2="3" />
                  </svg>
                </button>

                {download && (
                  <div
                    className="download_dropdown"
                    style={{
                      position: "absolute",
                      top: "110%",
                      left: 0,
                      backgroundColor: "white",
                      boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
                      borderRadius: "4px",
                      minWidth: "150px",
                      zIndex: 1000,
                    }}
                  >
                    {DownloadShowPDF === 1 &&
                      <div
                        onClick={() => {
                          handleDownlodingPDF();
                          setDownload(false);
                        }}
                        onMouseOver={(e) =>
                          (e.currentTarget.style.backgroundColor = "#f5f5f5")
                        }
                        onMouseOut={(e) =>
                          (e.currentTarget.style.backgroundColor = "#fff")
                        }
                        style={menuItemStyle}
                      >
                        Download PDF
                      </div>}

                    {DownloadShowCSV === 2 &&
                      <div
                        onClick={() => {
                          handleDownlodingCSV();
                          setDownload(false);
                        }}
                        onMouseOver={(e) =>
                          (e.currentTarget.style.backgroundColor = "#f5f5f5")
                        }
                        onMouseOut={(e) =>
                          (e.currentTarget.style.backgroundColor = "#fff")
                        }
                        style={{ ...menuItemStyle, borderBottom: "none" }}
                      >
                        Download CSV
                      </div>}
                  </div>
                )}
              </div>
            </div>}
        </div>
        <GridToolbarQuickFilter
          inputRef={searchInputRef}
          value={searchQuery}  // Show search query value in the search box
          onChange={handleSearchChange}  // Handle search input
          onClick={() => setHasintersected(true)}
          className="datagrid-search"
          // showClearButton={true}
          onBlur={handleBlur}
        />
        {searchQuery && (
          <button
            onClick={() => setSearchQuery('')}  // Clear the search query
            style={{ border: 'none', background: 'none', cursor: 'pointer', color: '#999', position: 'absolute', top: '50px', right: '20px' }}
          >
            X
          </button>
        )}
      </GridToolbarContainer>
    );
  };

  const CustomToolbar2 = () => {
    return (
      <GridToolbarContainer style={{ background: "#fff", display: "flex", justifyContent: "end", alignItems: "center" }}>
        <div style={{ display: "flex", gap: "16px", alignItems: "center", justifyContent: "end", marginRight: "13px" }}>
          {customFilter &&
            <div>
              <div className="dashboard_download" onClick={handleModelPopUp}>
                Filter
                <svg
                  className="filter"
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  viewBox="0 0 24 24"
                  style={{ cursor: "pointer" }}
                >
                  <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3" />
                </svg>
              </div>
            </div>}
          {DownloadShowFile &&
            <div>
              <div
                ref={dropdownRef}
                style={{
                  position: "relative",
                  display: "inline-block",
                  border: "1px solid #ff6600",
                  borderRadius: "99rem",
                }}
              >
                <button
                  className="dashboard_download"
                  onClick={() => setDownload((prev) => !prev)}
                >
                  Download{" "}
                  <svg
                    className="filter"
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    viewBox="0 0 24 24"
                  >
                    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                    <polyline points="7 10 12 15 17 10" />
                    <line x1="12" y1="15" x2="12" y2="3" />
                  </svg>
                </button>

                {download && (
                  <div
                    className="download_dropdown"
                    style={{
                      position: "absolute",
                      top: "110%",
                      left: 0,
                      backgroundColor: "white",
                      boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
                      borderRadius: "4px",
                      minWidth: "150px",
                      zIndex: 1000,
                    }}
                  >
                    {DownloadShowPDF === 1 &&
                      <div
                        onClick={() => {
                          handleDownlodingPDF();
                          setDownload(false);
                        }}
                        onMouseOver={(e) =>
                          (e.currentTarget.style.backgroundColor = "#f5f5f5")
                        }
                        onMouseOut={(e) =>
                          (e.currentTarget.style.backgroundColor = "#fff")
                        }
                        style={menuItemStyle}
                      >
                        Download PDF
                      </div>}

                    {DownloadShowCSV === 2 &&
                      <div
                        onClick={() => {
                          handleDownlodingCSV();
                          setDownload(false);
                        }}
                        onMouseOver={(e) =>
                          (e.currentTarget.style.backgroundColor = "#f5f5f5")
                        }
                        onMouseOut={(e) =>
                          (e.currentTarget.style.backgroundColor = "#fff")
                        }
                        style={{ ...menuItemStyle, borderBottom: "none" }}
                      >
                        Download CSV
                      </div>}
                  </div>
                )}
              </div>
            </div>}
        </div>
        <GridToolbarQuickFilter
          inputRef={searchInputRef}
          value={searchQuery}  // Show search query value in the search box
          onChange={handleSearchChange}  // Handle search input
          onClick={() => setHasintersected(true)}
          className="datagrid-search"
          // showClearButton={true}
          onBlur={handleBlur}
        />
        {searchQuery && (
          <button
            onClick={() => setSearchQuery('')}  // Clear the search query
            style={{ border: 'none', background: 'none', cursor: 'pointer', color: '#999', position: 'absolute', top: '50px', right: '20px' }}
          >
            X
          </button>
        )}
      </GridToolbarContainer>
    );
  };

  const CustomToolbar1 = () => {
    return (
      <GridToolbarContainer className="datagrid-content">
        <div className="missed_below_note_ranking">
          <div className="below_note_ranking">
            *Note  :   N/A is Not Available

          </div>
          <div className="below_note_ranking icon">
            <div className="green">
              <ArrowDropUpSharpIcon />-  Gained
            </div>

            <div className="rose">
              <ArrowDropDownIcon /> -   Dropped
            </div>

            <div className="orange">
              <SquareIcon />-  No Change
            </div>


          </div>
        </div>

        <div style={{ display: "flex", gap: "16px", alignItems: "center", justifyContent: "end" }}>
          {customFilter &&
            <div>
              <div className="dashboard_download" onClick={handleModelPopUp}>
                Filter
                <svg
                  className="filter"
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  viewBox="0 0 24 24"
                  style={{ cursor: "pointer" }}
                >
                  <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3" />
                </svg>
              </div>
            </div>}
          {DownloadShowFile &&
            <div>
              <div
                ref={dropdownRef}
                style={{
                  position: "relative",
                  display: "inline-block",
                  border: "1px solid #ff6600",
                  borderRadius: "99rem",
                }}
              >
                <button
                  className="dashboard_download"
                  onClick={() => setDownload((prev) => !prev)}
                >
                  Download{" "}
                  <svg
                    className="filter"
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    viewBox="0 0 24 24"
                  >
                    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                    <polyline points="7 10 12 15 17 10" />
                    <line x1="12" y1="15" x2="12" y2="3" />
                  </svg>
                </button>

                {download && (
                  <div
                    className="download_dropdown"
                    style={{
                      position: "absolute",
                      top: "110%",
                      left: 0,
                      backgroundColor: "white",
                      boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
                      borderRadius: "4px",
                      minWidth: "150px",
                      zIndex: 1000,
                    }}
                  >
                    {DownloadShowPDF === 1 &&
                      <div
                        onClick={() => {
                          handleDownlodingPDF();
                          setDownload(false);
                        }}
                        onMouseOver={(e) =>
                          (e.currentTarget.style.backgroundColor = "#f5f5f5")
                        }
                        onMouseOut={(e) =>
                          (e.currentTarget.style.backgroundColor = "#fff")
                        }
                        style={menuItemStyle}
                      >
                        Download PDF
                      </div>}

                    {DownloadShowCSV === 2 &&
                      <div
                        onClick={() => {
                          handleDownlodingCSV();
                          setDownload(false);
                        }}
                        onMouseOver={(e) =>
                          (e.currentTarget.style.backgroundColor = "#f5f5f5")
                        }
                        onMouseOut={(e) =>
                          (e.currentTarget.style.backgroundColor = "#fff")
                        }
                        style={{ ...menuItemStyle, borderBottom: "none" }}
                      >
                        Download CSV
                      </div>}
                  </div>
                )}
              </div>
            </div>}
        </div>
        <GridToolbarQuickFilter
          inputRef={searchInputRef}
          value={searchQuery}  // Show search query value in the search box
          onChange={handleSearchChange}  // Handle search input
          onClick={() => setHasintersected(true)}
          className="datagrid-search"
        />


        {searchQuery && (
          <button
            onClick={() => setSearchQuery('')}  // Clear the search query
            style={{ border: 'none', background: 'none', cursor: 'pointer', color: '#999', position: 'absolute', top: '50px', right: '20px' }}
          >
            X
          </button>
        )}
      </GridToolbarContainer>
    );
  };

  const CustomToolbar = () => {
    return (
      <GridToolbarContainer style={{ background: "#fff", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        {/* Custom Left Side Content */}
        <div className="below_note_ranking icon over_all_accessibility">
          {/* Very easy - Dark Green */}
          <div className="icons_dashboard_space" style={{ color: "#006400", display: "flex", alignItems: "center", background: "#d4ffd4" }}>
            {" "}
            <CircleIcon className="table_icons_dashboard" /><span style={{ color: "#0b2033" }}>Very easy</span>
          </div>

          {/* Easy - Green */}
          <div className="icons_dashboard_space" style={{ color: "#008000", display: "flex", alignItems: "center", background: "#bbe2bb" }}>
            {" "}
            <CircleIcon className="table_icons_dashboard" /><span style={{ color: "#0b2033" }}>Easy</span>
          </div>

          {/* Fairly easy - Orange */}
          <div className="icons_dashboard_space" style={{ color: "#FFA500", display: "flex", alignItems: "center", background: "#fae2b7" }}>
            {" "}
            <CircleIcon className="table_icons_dashboard" /><span style={{ color: "#0b2033" }}>Fairly easy</span>
          </div>

          {/* Okay - Light Orange */}
          <div className="icons_dashboard_space" style={{ color: "#FFD700", display: "flex", alignItems: "center", background: "#fff4b5" }}>
            {" "}
            <CircleIcon className="table_icons_dashboard" /><span style={{ color: "#0b2033" }}>Okay</span>
          </div>

          {/* Fairly difficult - Light brown */}
          <div className="icons_dashboard_space" style={{ color: "#D2B48C", display: "flex", alignItems: "center", background: "#ffe9cb" }}>
            {" "}
            <CircleIcon className="table_icons_dashboard" /><span style={{ color: "#0b2033" }}>Fairly difficult</span>
          </div>

          {/*  Difficult -  brown */}
          <div className="icons_dashboard_space" style={{ color: "#A52A2A", display: "flex", alignItems: "center", background: "#fbb8b8" }}>
            {" "}
            <CircleIcon className="table_icons_dashboard" /><span style={{ color: "#0b2033" }}>Difficult</span>
          </div>

          {/* Very Confusing - Light brown */}
          <div className="icons_dashboard_space" style={{ color: "#FF0000", display: "flex", alignItems: "center", background: "#ffc5c5" }}>
            {" "}
            <CircleIcon className="table_icons_dashboard" /><span style={{ color: "#0b2033" }}>Very Confusing</span>
          </div>
        </div>

        <div style={{ display: "flex", gap: "16px", alignItems: "center", justifyContent: "end" }}>
          <div onClick={handleModelPopUp} >
            <div className="dashboard_download" >
              Filter
              <svg
                className="filter"
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                viewBox="0 0 24 24"
                style={{ cursor: "pointer" }}
              >
                <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3" />
              </svg>
            </div>
          </div>
          <div>
            <div
              ref={dropdownRef}
              style={{
                position: "relative",
                display: "inline-block",
                border: "1px solid #ff6600",
                borderRadius: "99rem",
              }}
            >
              <button
                className="dashboard_download"
                onClick={() => setDownload((prev) => !prev)}
              >
                Download{" "}
                <svg
                  className="filter"
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  viewBox="0 0 24 24"
                >
                  <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                  <polyline points="7 10 12 15 17 10" />
                  <line x1="12" y1="15" x2="12" y2="3" />
                </svg>
              </button>

              {download && (
                <div
                  className="download_dropdown"
                  style={{
                    position: "absolute",
                    top: "110%",
                    left: 0,
                    backgroundColor: "white",
                    boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
                    borderRadius: "4px",
                    minWidth: "150px",
                    zIndex: 1000,
                  }}
                >
                  <div
                    onClick={() => {
                      handleDownlodingPDF();
                      setDownload(false);
                    }}
                    onMouseOver={(e) =>
                      (e.currentTarget.style.backgroundColor = "#f5f5f5")
                    }
                    onMouseOut={(e) =>
                      (e.currentTarget.style.backgroundColor = "#fff")
                    }
                    style={menuItemStyle}
                  >
                    Download PDF
                  </div>

                  <div
                    onClick={() => {
                      handleDownlodingCSV();
                      setDownload(false);
                    }}
                    onMouseOver={(e) =>
                      (e.currentTarget.style.backgroundColor = "#f5f5f5")
                    }
                    onMouseOut={(e) =>
                      (e.currentTarget.style.backgroundColor = "#fff")
                    }
                    style={{ ...menuItemStyle, borderBottom: "none" }}
                  >
                    Download CSV
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>

        {/* Default Search Box (Quick Filter) */}
        <GridToolbarQuickFilter
          inputRef={searchInputRef}
          value={searchQuery}  // Show search query value in the search box
          onChange={handleSearchChange}
          onClick={() => setHasintersected(true)}
        // className="datagrid-search"
        />
        {searchQuery && (
          <button
            onClick={() => setSearchQuery('')}  // Clear the search query
            style={{ border: 'none', background: 'none', cursor: 'pointer', color: '#999', position: 'absolute', top: '50px', right: '20px' }}
          >
            X
          </button>
        )}
      </GridToolbarContainer>
    );
  };


  useEffect(() => {

    if (hasintersected) {
      if (searchInputRef.current) {
        searchInputRef.current.focus();
      }
    }
  }, [hasintersected, searchQuery, filteredRows]);


  useEffect(() => {
    if (columns) {
      setCurrentColumns(columns);
      freezeColumn();
    }
  }, [columns])

  useEffect(() => {
    setRowLength(filteredRows.length);
    if (freezeColumnLength > 0 && !isTabletView) {
      findVirtualScroller();
    }
  }, [filteredRows])

  const findVirtualScroller = () => {
    const virtualScrollerElement = document.querySelector(
      ".MuiDataGrid-virtualScroller"
    );
    if (!virtualScrollerElement) {
      setTimeout(findVirtualScroller, 100);
    } else {
      virtualScrollerElement.addEventListener(
        "scroll",
        handleScrollHorizontal
      );
      return () => {
        virtualScrollerElement.removeEventListener(
          "scroll",
          handleScrollHorizontal
        );
      };
    }
  };

  let debounceTimeout;

  const handleScrollHorizontal = (() => {
    clearTimeout(debounceTimeout);
    debounceTimeout = setTimeout(() => {
      const isTabletView = window.innerWidth <= 768;

      const currentScrollPos = document.querySelector(
        ".MuiDataGrid-virtualScroller"
      ).scrollLeft;

      const columnsHeaders = document.querySelectorAll(
        isTabletView
          ? ".MuiDataGrid-columnHeader" // All columns scroll in tablet view
          : `.MuiDataGrid-columnHeader:not(.MuiDataGrid-columnHeader:nth-child(-n+${freezeColumnLength}))` // Freeze first three columns on larger screens
      );
      columnsHeaders.forEach((columnHeader) => {
        columnHeader.style.transform = `translate3d(-${currentScrollPos}px, 0px, 0px)`;
      });
    }, 20);

  })


  return (
    <>
      {/* <div
        className="data_table analysis_summary_table analysed_table_Data over_all_accessibility"
        style={{ width: "100%" }}
      > */}

      <div className="data_table accessbility_score_table accessbility_report_score_table" style={{ width: "100%" }}>
        <div style={{ height: filteredRows.length < 5 ? 'unset' : isMobile ? tableHeight.mobile : tableHeight.web, width: "100%" }} className="over_all_accessibility analysissummary_table">
          <DataGrid
            sx={{
              "&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell": {
                py: "8px",
              },
              "&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell": {
                py: "15px",
              },
              "&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell": {
                py: "22px",
              },
              "& .MuiDataGrid-columnHeaderTitle": {
                whiteSpace: "normal",
                lineHeight: "normal",
              },
              "&, [class^=MuiDataGrid]": { border: "none" },
              "& .MuiDataGrid-columnHeaders": (freezeColumnLength > 0 && !isTabletView) ? {
                position: "sticky",
                "& .MuiDataGrid-columnHeadersInner": {
                  transform: "none !important",
                  "& div": dataGridSxHeader
                }
              } : {},
              "& .MuiDataGrid-columnSeparator--sideRight": {
                display: "none"
              },
              ...dataGridSx
            }}
            rows={filteredRows}
            columns={columnsWithDrag}
            getRowId={(row) => row.sid}
            getRowHeight={() => "auto"}
            autoHeight={rowLength === 0}
            pageSizeOptions={[10, 30, 50, 75, 100]}
            paginationModel={{
              page: page - 1,
              pageSize: rowsPerPage,
            }}
            onPaginationModelChange={(model) => {
              setPage(model.page + 1);
              setRowsPerPage(model.pageSize);
            }}
            disableColumnFilter
            disableColumnSelector
            disableDensitySelector
            disableRowSelectionOnClick
            {...(checkbox && {
              checkboxSelection: true,
              onRowSelectionModelChange: (ids) => {
                const selectedRowsData = ids.map((id) =>
                  rows.find((row) => row.id === id)
                );
                setSelectedRows(selectedRowsData);
              },
            })}
            slots={{
              noRowsOverlay: MyCustomNoRowsOverlay,
              toolbar: datagridval === 1 ? CustomToolbar : datagridval === 3 ? CustomToolbar1 : datagridval === 2 ? CustomToolbar2 : datagridval === 4 ? customToolFunction : datagridval === 5 ? CustomToolbar5 : null,
              noResultsOverlay: MyCustomNoRowsOverlay,
              footer: () => (
                <Box className="table-footer-container">
                  <Box className="table-footer-pagination">
                    <Pagination
                      className="table-pagination"
                      count={totalPages}
                      page={page}
                      onChange={handlePageChange}
                    />
                  </Box>
                  {!defaultPerPage &&
                    <MSelect
                      value={rowsPerPage}
                      onChange={handleRowsPerPageChange}
                      size="small"
                      className="table-footer-select"
                    >
                      <MenuItem value={10}>10 per page</MenuItem>
                      <MenuItem value={30}>30 per page</MenuItem>
                      <MenuItem value={50}>50 per page</MenuItem>
                      <MenuItem value={75}>75 per page</MenuItem>
                      <MenuItem value={100}>100 per page</MenuItem>
                    </MSelect>}
                </Box>
              ),
            }}
            slotProps={{
              toolbar: {
                showQuickFilter: true,
              },
            }}
          />
        </div>
      </div>
    </>
  )
}